/**
 * API Endpoints Constants - V2 Only
 * Centralized management of V2 API endpoints
 */
import { environment } from '@lmc-env/environment';

const BASE_URL = environment.DO_URL;

// Auth Endpoints (v2)
export const AUTH = {
	LOGIN: `${BASE_URL}/v2/auth/login`,
	LOGOUT: `${BASE_URL}/v2/auth/logout`,
	REFRESH_TOKEN: `${BASE_URL}/v2/auth/refreshToken`,
} as const;

// User Endpoints (v2)
export const USER = {
	ME: `${BASE_URL}/v2/users/me`,
} as const;

export const API = {
	AUTH,
	USER,
} as const;
